import { useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Menu, X } from "lucide-react";
import logoIcon from "@/assets/logo-warmzapp.webp";

const navLinks = [
  { label: "Como Funciona", href: "#como-funciona" },
  { label: "Funcionalidades", href: "#funcionalidades" },
  { label: "Preços", href: "#precos" },
  { label: "FAQ", href: "#faq" },
];

const Navbar = () => {
  const [open, setOpen] = useState(false);

  return (
    <motion.nav
      initial={{ y: -80 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.6, ease: "easeOut" }}
      className="fixed top-0 left-0 right-0 z-50 glass-navbar"
    >
      <div className="container mx-auto flex items-center justify-between px-4 py-4 md:px-8">
        {/* Logo */}
        <a href="#" className="flex items-center gap-1 font-display text-2xl font-bold tracking-tight text-foreground">
          <img src={logoIcon} alt="" className="h-10 w-auto" />
          Warm<span className="text-primary">Zapp</span>
        </a>

        {/* Desktop Links */}
        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="text-sm text-muted-foreground hover:text-foreground transition-colors"
            >
              {l.label}
            </a>
          ))}
        </div>

        {/* Desktop CTA */}
        <div className="hidden md:flex items-center gap-4">
          <Link to="/login" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
            Entrar
          </Link>
          <Link
            to="/signup"
            className="inline-flex items-center px-5 py-2.5 rounded-lg bg-accent text-accent-foreground text-sm font-semibold glow-green transition-transform hover:scale-105"
          >
            Começar Agora
          </Link>
        </div>

        {/* Mobile toggle */}
        <button onClick={() => setOpen(!open)} className="md:hidden text-foreground">
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile menu */}
      {open && (
        <motion.div
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          className="md:hidden glass-navbar border-t border-warmz-glass-border/30 px-4 pb-6 pt-2"
        >
          {navLinks.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="block py-3 text-sm text-muted-foreground hover:text-foreground"
            >
              {l.label}
            </a>
          ))}
          <Link
            to="/signup"
            className="mt-2 block w-full text-center px-5 py-2.5 rounded-lg bg-accent text-accent-foreground text-sm font-semibold glow-green"
          >
            Começar Agora
          </Link>
        </motion.div>
      )}
    </motion.nav>
  );
};

export default Navbar;
